/**
 * Preserves 0 (a persistable warning state); coerces blank/whitespace-only/negative/NaN to null.
 * Strings are trimmed before parsing -- Number(' ') is 0, not NaN, so a whitespace-only
 * cell/input must be treated as blank rather than silently coerced into a valid quantity of 0.
 */
export const parseSupplierQuantity = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;

  const normalized = typeof value === 'string' ? value.trim() : value;
  if (normalized === '') return null;

  const parsed = typeof normalized === 'number' ? normalized : Number(normalized);

  if (Number.isNaN(parsed) || parsed < 0) return null;
  return parsed;
};
